import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
  text-decoration:none;
}
*:focus{
  outline:0;
}


html,
body,
#root {
  min-height: 100vh;
}
#root {
  width: 100%;
  overflow: hidden;
  max-width: 100vw;
  position: relative;
}

body, input, button{
  font-size: 16px;
}

body {
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  width: 100%;
  font-family: 'Poppins', sans-serif;
  color:#000

}
.LoadingBar{
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height: 3px;
  z-index:10;
}
`;
